<template>
  <v-main :anchor-layout="layoutName">
    <publicHighlight></publicHighlight>
    <!-- 手機版menu -->
    <publicMenuMobile
      v-if="applicationLoaded"
      v-model="showNavigation"
    ></publicMenuMobile>

    <v-app-bar app fixed class="d-print-none" clipped-left height="56">
      <v-touch @press="goCms" :press-options="{ time: 3000 }">
        <router-link :to="{ name: 'home' }" class="black--text text-decoration-none">
          <v-toolbar-title class="d-flex pa-2 align-center">
            <v-img width="25" height="25" lazy-src :src="logoUrl"></v-img>
            <span class="pa-2">{{siteName}}</span>
          </v-toolbar-title>
        </router-link>
      </v-touch>

      <v-spacer></v-spacer>

      <!-- 電腦版menu -->
      <publicMenuDesktop
        v-if="applicationLoaded"
        class="hidden-sm-and-down"
      ></publicMenuDesktop>

      <v-spacer></v-spacer>

      <adminControl v-if="isUser"></adminControl>

      <memberControl v-if="!isUser"></memberControl>

      <v-cart-button v-if="applicationLoaded"></v-cart-button>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click.stop="toggleNavigation"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <div
      v-if="applicationLoaded"
      anchor-router-view-container
      :class="{ container: hasPageGap }"
    >
      <breadcrumb></breadcrumb>
      <router-view :page="$route.name"></router-view>
    </div>

    <partialFooter></partialFooter>
  </v-main>
</template>

<script lang="babel" type="text/babel">
import layoutMixin from 'layouts/layoutMixin.js'
import publicHighlight from 'layouts/public/publicHighlight.vue'
export default {
  mixins: [layoutMixin],
  data() {
    return {
      layoutName: 'public',
      showNavigation: false,
    }
  },
  created() {
    this.setupLayout()
    this.$router.replace({ name: 'member.login' })
  },
  methods: {
    toggleNavigation() {
      this.showNavigation = !this.showNavigation
      this.$nextTick(() => {
        this.$root.$emit('onPageResize')
      })
    },
    goCms() {
      this.$router.push({ name: 'admin.home' })
    },
  },
  computed: {
    siteName() {
      return this.$store.getters['base/siteName']
    },
    isUser() {
      return this.$store.getters['token/isUser']
    },
  },
  components: {
    partialFooter: () => import('layouts/footer.vue'),
    publicMenuDesktop: () => import('layouts/public/publicMenuDesktop.vue'),
    publicMenuMobile: () => import('layouts/public/publicMenuMobile.vue'),
    publicHighlight,
    memberControl: () => import('components/memberControl/memberControl.vue'),
  },
  watch: {
    async application(after, before) {
      if(after === true) {
        await this.$nextTick()
        this.$ssr()
      }
    }
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>